import { vErrors } from '@/validation'
import vClickaway from './v-clickaway'
import vFocus from './v-focus'
import vSort from './v-sort'
import vFeature from './v-feature'
import vNA from './v-na'
import filters from './filters'
import omitBy from 'lodash/omitBy'

export default {
    install(Vue) {
        Vue.directive('errors', vErrors)
        Vue.directive('clickaway', vClickaway)
        Vue.directive('focus', vFocus)
        Vue.directive('sort', vSort)
        Vue.directive('feature', vFeature)
        Vue.directive('na', vNA)

        Object.keys(filters).map(filterName => Vue.filter(filterName, filters[filterName]))

        Vue.mixin({
            methods: {
                /**
                 * Глобальный метод для удобной работы с фильтрами, сортировкой и пагинацией.
                 *
                 * @param {Object} filter
                 */
                applyFilter(filter = {}) {
                    const query = omitBy(Object.assign({}, this.$route.query, filter), value => !value || value.length === 0)

                    if (query.page <= 1) {
                        delete query.page
                    }

                    this.$router.push({ query })
                }
            }
        })
    }
}
